export const columns = [
  {
    key: 'name',
    label: 'Name'
  },
  {
    key: 'status',
    label: 'Status'
  },
  {
    key: 'stage',
    label: 'Stage'
  },
  {
    key: 'updated',
    label: 'Updated'
  },
  {
    key: 'actions',
    label: 'Actions'
  }
];
